import { useState } from "react"
import { Box, Tabs, Tab } from "@mui/material"
import CoachesSchedule from "./fragement/CoachSchedule"
import MySchedule from "./fragement/MySchedule"
import mechantConfig from "../app/mechant.config"

const MemberSchedule = () => {
    const [tabIndex, setTabIndex] = useState(0)
    // const [merchant, setMerchant] = useState(null)
    const handleTabChange = (event, idx) => {
        setTabIndex(idx)
    }
    // useEffect(() => {
    //     const mm = mechantConfig.getMerchant()
    //     setMerchant(mm)
    // }, [])
    const merchant = mechantConfig.getMerchant()
    return <Box>
        <Tabs value={tabIndex} onChange={handleTabChange} sx={{ mb: 2 }}>
            <Tab label={"My schedules"} key={0} />
            {merchant?.show_coach_schedule && <Tab label={"Coach's Schedules"} key={1} />}
        </Tabs>

        {tabIndex == 0 &&  <MySchedule />}
        {merchant?.show_coach_schedule && tabIndex == 1 && <CoachesSchedule />}
    </Box>
}

export default MemberSchedule